'use strict';

import measurementsHistoryTemplate from './measurementsHistory.directive.html';

export default angular
  .module('maestro.directives.components.measurementsHistory', [])

  .directive('measurementsHistory', function($filter) {
    const $t = $filter('translate');
    return {
      restrict: 'E',
      template: measurementsHistoryTemplate,
      scope: {
        device: '=', // Current device
        location: '=', // Current device location
        parameter: '=', // Current device parameter data
        index: '=', // Current device parameter index (optional)
        onBack: '&', // Back button click callback
        autoUpdate: '=' // Boolean - Set false to disable autoupdate
      },
      controller: ($scope, $timeout, $q, utils, I18nService, DevicesService) => {
        const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
        const PAGE_SIZE = 100;
        const AUTO_UPDATE_PERIOD = 15000;
        $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
        $scope.locale = I18nService.getLocale();
        $scope.initialLoading = true;
        $scope.showMoreLoading = false;
        $scope.datepickerButton = $('#toggle-datepicker');

        /**
         * We need to calculate this only once to make measurement comparison by date works.
         * Server some times returns measurements with startDate parameter we pass.
         */
        const dayBefore = new Date().getTime() - 24 * 60 * 60 * 1000;

        let autoUpdateTimeout;

        angular.extend($scope, {
          onShowMoreButtonClick: onShowMoreButtonClick,
          parameterValueToStr: parameterValueToStr,
          recentReading: false,
          back: back
        });

        init();

        function init() {
          $scope.$watchGroup(['parameter', 'index', 'device', 'location'], () => {
            stopAutoUpdateTimer();
            if ($scope.parameter && $scope.device && $scope.location) {
              initHistory();
            }
          }, true);
          $scope.$watch('filterDate', (newVal, oldVal) => {
            if (newVal === oldVal || !$scope.parameter || !$scope.device || !$scope.location) {
              return;
            }

            if (newVal && newVal.length > 0) {
              stopAutoUpdateTimer();
              getExactDateMeasurements();
              // Fix for datepicker to eliminate call duplicates
            } else if (newVal === null || (newVal === '' && oldVal !== null)) {
              startAutoUpdateTimer();
              getLast24HoursMeasurements();
            }
          });
          $scope.$on('$destroy', () => {
            stopAutoUpdateTimer();
          });
        }

        function initHistory() {
          $scope.initialLoading = true;
          $scope.filterDate = null;

          $scope.measurementTimeFormat = $t('datetime.HMS12');
          $scope.dateTimeFormat = $t('datetime.measurements.date');
          $scope.datePickerDateTimeFormat = $t('datetime.measurements.datePickerDate');
          $scope.dateFormat = $t('datetime.measurements.date');

          $scope.dateDatePickerOptions = {
            language: $scope.locale.code,
            position: 'bottom left',
            autoClose: true,
            view: 'days',
            minView: 'days',
            dateFormat: $scope.datePickerDateTimeFormat,
            maxDate: new Date(),
            timepicker: false,
            clearButton: true,
            range: true,
            // toggleSelected: false
          };

          // Location timezone setup
          $scope.useLocationTimezone = !!$scope.location.timezone && !!moment.tz.zone($scope.location.timezone.id);
          if ($scope.useLocationTimezone) {
            // if location timezone defined and correct - use it
            $scope.timezone = $scope.location.timezone.id;
          } else {
            // if no location timezone is present - use local timezone
            $scope.timezone = moment.tz.guess();
          }
          $scope.timezone = $scope.timezone || 'GMT'; // just in case
          $scope.timezoneShift = moment.tz($scope.timezone).format('Z');

          stopAutoUpdateTimer();
          getLast24HoursMeasurements()
            .then(() => startAutoUpdateTimer());
        }

        function onShowMoreButtonClick() {
          if ($scope.filterDate && $scope.filterDate.length > 0) {
            showMoreExactDateMeasurements();
          } else {
            showMoreLast24HoursMeasurements();
          }
        }

        function startAutoUpdateTimer() {
          if (autoUpdateTimeout) {
            return;
          }
          autoUpdateTimeout = $timeout(() => {
            if ($scope.autoUpdate === false) {
              autoUpdateTimeout = void 0;
              startAutoUpdateTimer();
              return;
            }
            getLatestMeasurements()
              .then((measurements) => {
                if (!autoUpdateTimeout || ($scope.filterDate && $scope.filterDate.length > 0)) {
                  return;
                }
                $scope.measurements = processMeasurements(measurements, true);
                autoUpdateTimeout = void 0;
                startAutoUpdateTimer();
              });
          }, AUTO_UPDATE_PERIOD);
        }

        function stopAutoUpdateTimer() {
          $timeout.cancel(autoUpdateTimeout);
          autoUpdateTimeout = void 0;
        }

        function getLatestMeasurements() {
          if ($scope.loading) {
            return $q.when();
          }
          let startDate = dayBefore;
          let endDate = new Date().getTime();

          return DevicesService.getLastNMeasurements($scope.device.id,
            PAGE_SIZE,
            {
              locationId: $scope.location.id,
              paramName: $scope.parameter.name,
              startDate: startDate,
              endDate: endDate,
              index: $scope.index,
            })
            .then((data) => {
              return data.readings;
            }, (err) => {
              utils.handleApiError(err);
            });
        }

        function getExactDateMeasurements() {
          if ($scope.loading) {
            return $q.when();
          }
          $scope.measurements = void 0;
          $scope.hasMoreMeasurements = false;

          let endDateTemp = $scope.filterDate[$scope.filterDate.length - 1];
          let startDate = moment.tz(moment($scope.filterDate[0])
            .format('L'), 'L', $scope.timezone)
            .startOf('day')
            .valueOf();
          let endDate = moment.tz(moment(endDateTemp)
            .format('L'), 'L', $scope.timezone)
            .endOf('day')
            .valueOf();

          $scope.last24Hours = false;
          return getMeasurementHistory(startDate, endDate);
        }

        function showMoreExactDateMeasurements() {
          if (!$scope.measurements || $scope.measurements.length <= 0 || $scope.loading) {
            return $q.when();
          }
          let date = $scope.filterDate[0];
          let startDate = moment.tz(moment(date).format('L'), 'L', $scope.timezone)
            .startOf('day')
            .valueOf();
          // We take endDate as the earliest measurement timestamp to take next "Page"
          let endDate = $scope.measurements[$scope.measurements.length - 1].timeStampMs;

          $scope.showMoreLoading = true;
          return getMeasurementHistory(startDate, endDate)
            .then(() => {
              $scope.showMoreLoading = false;
            });
        }

        function getLast24HoursMeasurements() {
          if ($scope.loading) {
            return $q.when();
          }
          $scope.measurements = void 0;
          $scope.hasMoreMeasurements = false;

          let startDate = dayBefore;
          let endDate = new Date().getTime();

          $scope.last24Hours = true;
          return getMeasurementHistory(startDate, endDate);
        }

        function showMoreLast24HoursMeasurements() {
          if (!$scope.measurements || $scope.measurements.length <= 0 || $scope.loading) {
            return $q.when();
          }
          let startDate = dayBefore;
          // We take endDate as the earliest measurement timestamp to take next "Page"
          let endDate = $scope.measurements[$scope.measurements.length - 1].timeStampMs;

          $scope.showMoreLoading = true;
          return getMeasurementHistory(startDate, endDate)
            .then(() => {
              $scope.showMoreLoading = false;
            });
        }

        function getMeasurementHistory(startDate, endDate) {
          $scope.loading = true;
          return DevicesService.getLastNMeasurements($scope.device.id,
            PAGE_SIZE,
            {
              locationId: $scope.location.id,
              paramName: $scope.parameter.name,
              startDate: startDate,
              endDate: endDate,
              index: $scope.index,
            })
            .then((data) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              $scope.measurements = processMeasurements(data.readings);

              /**
               * Most recent reading always returned by API even if there is no measurements in giving dates.
               * We have to use lastMeasurementTimeMs instead of timeStampMs for such measurement.
               */
              $scope.recentReading = !!$scope.measurements && $scope.measurements.length > 0 && !!$scope.measurements[0].params[0].lastUpdateTimeMs;

            }, (err) => {
              $scope.loading = false;
              $scope.initialLoading = false;
              $scope.hasMoreMeasurements = false;
              utils.handleApiError(err);
            });
        }

        function processMeasurements(newMeasurements, doNotCalcHasMoreMeasurements) {
          if (!doNotCalcHasMoreMeasurements) {
            $scope.hasMoreMeasurements = (newMeasurements && newMeasurements.length >= PAGE_SIZE);
          }

          if (!newMeasurements || newMeasurements.length <= 0) {
            return $scope.measurements;
          }
          let result = ($scope.measurements || []).concat(newMeasurements || [])
            .sort((a, b) => b.timeStampMs - a.timeStampMs);

          // Remove duplicates
          result = result
            .filter((m1, index) =>
              index === result.findIndex(m2 => angular.equals(m1, m2)));

          return result;
        }

        function parameterValueToStr(value) {
          return utils.deviceParameterToString($scope.parameter, value, $scope.index, $scope.locale.code);
        }

        function back() {
          $scope.onBack();
        }
      }
    };
  })

  .name;
